import './Diagram.component.css'

import { Circle, Layer, Stage, Text } from 'react-konva'

import React from 'react'
import SampleContainerComponent from '../SampleContainer/SampleContainer.component'

export class DiagramComponent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      radius: 250,
      width: 500,
      height: 500,
      visible: true,
      opacity: 1,
      bigCircle: null,
      groupCircles: null,
      sample_containers: null,
    }
  }

  mapResponseToSampleList(response) {
    const result = []
    response.forEach(item => {
      result.push({
        sampleName: item.BLSample_name,
        proteinAcronyme: item.Protein_acronym,
        position: item.BLSample_location,
        status: item.BLSample_blSampleStatus ? item.BLSample_blSampleStatus : 'FILLED',
      })
    })
    return result
  }

  getKonvaCircle(
    radius,
    sample_container_position_from_top,
    sample_container_position_from_left,
    sample_container_background_color,
    sample_container_border_color
  ) {
    return (
      <Circle
        radius={radius}
        y={sample_container_position_from_top}
        x={sample_container_position_from_left}
        fill={sample_container_background_color}
        stroke={sample_container_border_color}
        strokeWidth={1}
        strokeEnabled
      />
    )
  }

  renderGroupCircle() {
    const circles = []
    this.props.configuration.group_drawing.circles.forEach(circle => {
      circles.push(
        this.getKonvaCircle(
          circle.group_circle_radius,
          circle.group_circle_position_from_top,
          circle.group_circle_position_from_left,
          circle.group_circle_background_color,
          circle.group_circle_border_color,
          circle.group_circle_border_size
        )
      )
    })

    return circles
  }

  componentDidMount() {
    this.setState({
      sample_containers: this.makeSampleContainers(),
    })
  }

  // FIXME bmo 20210210
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps() {
    this.setState({
      sample_containers: this.makeSampleContainers(),
    })
  }

  componentWillUnmount() {
    this.stage.destroyChildren()
    this.stage.destroy()
  }

  makeLegendNumbers() {
    const numbers = []

    this.props.configuration.sample_containers_groups.forEach(group => {
      group.sample_containers.forEach(sample_container => {
        numbers.push(
          <Text
            draggable={false}
            y={sample_container.sample_container_drawing.sample_container_index_position_from_top}
            x={sample_container.sample_container_drawing.sample_container_index_position_from_left}
            text={sample_container.position_in_container}
            fontSize={30}
            fontFamily="Calibri"
            fill="white"
          />
        )
      })
    })

    return numbers
  }

  makeSampleContainers() {
    const sample_containers = []
    this.props.configuration.sample_containers_groups.forEach(group => {
      group.sample_containers.forEach(sample_container => {
        const matchingTypeContainers = this.props.containersInfo
          .filter(container => !!container.beamlineLocation)
          .filter(
            container =>
              container.beamlineLocation
                .toString()
                .toLowerCase()
                .trim()
                .localeCompare(this.props.configuration.name.toString().toLowerCase().trim()) === 0
          )

        const matching_container = matchingTypeContainers.find(
          candidat => candidat.sampleChangerLocation === sample_container.position_in_container
        )

        if (matching_container) {
          const samples = this.mapResponseToSampleList(
            this.props.samplesGroupedByContainerId[matching_container.containerId]
          )

          sample_containers.push(
            <SampleContainerComponent
              onMouseOverSample={() => {}}
              updateSamplesOfSelectedSampleContainerCallback={selected => {
                this.props.updateSamplesOfSelectedSampleContainerCallback(selected)
              }}
              updateSelectedSampleContainerCallback={selected => {
                this.props.updateSelectedSampleContainerCallback(selected)
              }}
              fetchDataCallback={() => {
                this.props.fetchDataCallback()
              }}
              user={this.props.user}
              username={this.props.user.username}
              position_in_container={sample_container.position_in_container}
              showSamples
              status="FILLED"
              theOneContainer={matching_container}
              selectedShipment={this.props.selectedShipment}
              samples={samples}
              selectedSampleContainer={this.props.selectedSampleContainer}
              configuration={this.props.configuration}
              sample_container_radius={sample_container.sample_container_drawing.sample_container_radius}
              sample_container_position_from_top={
                sample_container.sample_container_drawing.sample_container_position_from_top
              }
              sample_container_position_from_left={
                sample_container.sample_container_drawing.sample_container_position_from_left
              }
            />
          )
        } else {
          sample_containers.push(
            <SampleContainerComponent
              onMouseOverSample={() => {}}
              updateSelectedSampleContainerCallback={selected => {
                this.props.updateSelectedSampleContainerCallback(selected)
              }}
              updateSamplesOfSelectedSampleContainerCallback={selected => {
                this.props.updateSamplesOfSelectedSampleContainerCallback(selected)
              }}
              fetchDataCallback={() => {
                this.props.fetchDataCallback()
              }}
              user={this.props.user}
              username={this.props.user.username}
              position_in_container={sample_container.position_in_container}
              showSamples
              theOneContainer={matching_container}
              selectedShipment={this.props.selectedShipment}
              status="FILLED"
              samples={[]}
              selectedSampleContainer={this.props.selectedSampleContainer}
              configuration={this.props.configuration}
              sample_container_radius={sample_container.sample_container_drawing.sample_container_radius}
              sample_container_position_from_top={
                sample_container.sample_container_drawing.sample_container_position_from_top
              }
              sample_container_position_from_left={
                sample_container.sample_container_drawing.sample_container_position_from_left
              }
            />
          )
        }
      })
    })
    return sample_containers
  }

  render() {
    const style = {
      width: '500px',
      height: '500px',
    }

    return (
      this.state.sample_containers && (
        <div style={style} key="diagram-component">
          <Stage
            width={this.state.width}
            height={this.state.height}
            visible={this.state.visible}
            opacity={this.state.opacity}
            ref={ref => (this.stage = ref)}
          >
            <Layer>
              {this.getKonvaCircle(
                this.state.radius,
                this.state.height / 2,
                this.state.width / 2,
                this.props.configuration.container_background_color,
                this.props.configuration.container_border_color
              )}
              {this.renderGroupCircle()}
            </Layer>
            {this.state.sample_containers}
            <Layer>{this.makeLegendNumbers()}</Layer>
          </Stage>
        </div>
      )
    )
  }
}

export default DiagramComponent

DiagramComponent.propTypes = {}
